module.exports = __webpack_public_path__ + "img/1200.f3d844f1.jpg";